<template>
  <div id="app__ernest">
    <header class="app__header__ernest">
      <div>
        <u-icon>d</u-icon>
      </div>
      <div>
        <div><span>Question de Likert</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>

    <section class="app__section__ernest">
      <h1>{{ $t('pages.questions.LikertCreation.title.name') }}</h1>

      <likert-form :is-clone="isClone"
                   :is-modification="false"
                   @save="create"
      />
    </section>
  </div>
</template>

<script>
import likertForm from '@/components/questions/formLikert.vue'
import { mapActions } from 'vuex'

export default {
  name: 'questionLikertCreation',
  components: {
    likertForm
  },
  data: () => ({
    isClone: false
  }),
  created () {
    if (this.$route.params.id !== undefined) {
      this.isClone = true
    }
  },
  methods: {
    ...mapActions('Questions', [
      'createQuestion'
    ]),
    async create (payload) {
      await this.createQuestion(
        {
          question: payload.question,
          saveType: payload.saveType
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/styleAppErnest";
</style>
